import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

type CodeName = { id: number; code?: string | null; name?: string | null };
type VesselRef = {
  id: number;
  vesselName?: string | null;
  vesselAbrv?: string | null;
  name?: string | null;
  abrv?: string | null;
};

export interface PmsEquipmentSystem {
  id: number;
  vesselId: number;
  departmentId: number;
  criticalityId: number;
  recordStatusId: number;
  parentSystemId?: number | null;
  code: string;
  name: string;
  description?: string | null;
  systemType?: string | null;
  displayOrder?: number | null;
  isActive?: boolean;
  vessel?: VesselRef | null;
  department?: CodeName | null;
  criticality?: CodeName | null;
  recordStatus?: CodeName | null;
  parentSystem?: CodeName | null;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

export const usePmsEquipmentSystems = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<PmsEquipmentSystem> | PmsEquipmentSystem[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<PmsEquipmentSystem>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePmsEquipmentSystem = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<PmsEquipmentSystem>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
